export const Copy = () => {
    return <div>Copy</div>
}
